import React from "react";
import styled from "styled-components";
import { Header } from "./components/Header";
import { Uploader } from "./components/Uploader";
import "./App.css";

const Container = styled.div`
  max-width: 880px;
  margin: 0 auto;
  padding: 0 80px;
  @media screen and (max-width: 767px) {
    padding: 0 16px;
  }
`;
const Footer = styled.div`
  padding-bottom: 80px;
`;
const Copyright = styled.div`
  text-align: center;
  font-size: 14px;
`;

function App() {
  return (
    <>
      <Header />
      <Container>
        <Uploader />
      </Container>
      <Footer>
        <Copyright>
          &copy;{" "}
          <a
            href="https://twitter.com/kokushing"
            target="_blank"
            rel="noreferrer"
          >
            kokushing
          </a>
        </Copyright>
      </Footer>
    </>
  );
}

export default App;
